/**
 * StringValidation is a collection of static methods for validating strings.
 * The most common use case is to validate user input for forms.
 *
 * The constructor is marked private to prevent instantiation from outside the class,
 * mimicking a static class pattern commonly used in other languages.
 * All methods are defined as static and should be accessed directly
 * via the class (e.g., StringValidation.isStringEmpty(...)).
 */
class StringValidation {
    private constructor() {
        return
    }

    /**
     * Checks if a string is empty or contains only whitespace characters.
     *
     * @param str - The string to check
     * @returns true if the string is empty or contains only whitespace characters (spaces, tabs, newlines), false otherwise
     *
     * @example
     * StringValidation.isEmpty("")         returns true
     * StringValidation.isEmpty("   ")      returns true
     * StringValidation.isEmpty("John")     returns false
     * StringValidation.isEmpty("John Doe") returns false
     */
    static isEmpty(str: string): boolean {
        return str.length === 0 || !/\S/.test(str)
    }
}

export { StringValidation }
